import React, { Component } from "react";
import {
  Container,
  Grid,
  Header,
  Tab,
  Loader,
  Message,
  Button,
} from "semantic-ui-react";
import { catalogLogsApi } from "@api/auditLogs/catalogLogs";
import { ActivityLogList } from "@modules/AuditLogs/CatalogLogging/ActivityLogList";
import HeaderSubHeader from "semantic-ui-react/dist/commonjs/elements/Header/HeaderSubheader";
import { AuditService } from "@api/audit/audit";
import { AuditLogsOverview } from "@modules/AuditLogs/OverviewLogging/AuditLogsOverview";
import { authenticationService } from "@authentication/services/AuthenticationService";
import { sessionManager } from "@authentication/services/SessionManager";

export class CatalogActivityLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auditLogs: [],
      allAuditLogs: [],
      loading: false,
      allLoading: false,
      error: null,
      allError: null,
      total: 0,
      allTotal: 0,
      currentPage: 1,
      currentSize: 10,
      paginatedAuditLogs: [],
    };
  }

  componentDidMount() {
    this.fetchAuditLogs();
    this.fetchAllAuditLogs();
  }

  fetchAuditLogs = async () => {
    this.setState({ loading: true, error: null });
    try {
      const response = await catalogLogsApi.get();
      this.setState({
        auditLogs: response.data || [],
        total: response.total || 0,
        loading: false,
      });
    } catch (error) {
      this.setState({
        error: `Failed to load audit logs: ${error.message}. Status: ${
          error.response?.status || "Unknown"
        }`,
        loading: false,
      });
    }
  };

  fetchAllAuditLogs = async () => {
    this.setState({ allLoading: true, allError: null });
    try {
      const logs = await AuditService.getAuditLogs();
      this.setState(
        {
          allAuditLogs: logs || [],
          allTotal: logs.length || 0,
          allLoading: false,
        },
        this.updatePaginatedLogs
      );
    } catch (error) {
      this.setState({
        allError: `Failed to load all audit logs: ${error.message}. Status: ${
          error.status || "Unknown"
        }`,
        allLoading: false,
      });
    }
  };

  updatePaginatedLogs = () => {
    const { allAuditLogs, currentPage, currentSize } = this.state;
    const startIndex = (currentPage - 1) * currentSize;
    const endIndex = startIndex + currentSize;
    const paginatedLogs = allAuditLogs.slice(startIndex, endIndex);

    this.setState({ paginatedAuditLogs: paginatedLogs });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, this.updatePaginatedLogs);
  };

  handlePageSizeChange = (size) => {
    this.setState(
      { currentSize: size, currentPage: 1 }, // Reset to page 1 to avoid out-of-range
      this.updatePaginatedLogs
    );
  };

  renderOverviewTab = () => {
    const {
      paginatedAuditLogs,
      allLoading,
      allError,
      allTotal,
      currentPage,
      currentSize,
    } = this.state;

    return (
      <Tab.Pane>
        <AuditLogsOverview
          allAuditLogs={paginatedAuditLogs}
          allLoading={allLoading}
          allError={allError}
          allTotal={allTotal}
          fetchAllAuditLogs={this.fetchAllAuditLogs}
          currentPage={currentPage}
          currentSize={currentSize}
          onPageChange={this.handlePageChange}
          onPageSizeChange={this.handlePageSizeChange}
        />
      </Tab.Pane>
    );
  };

  renderCatalogLogTab = () => {
    const { auditLogs, loading, error, total } = this.state;

    if (loading) {
      return (
        <Tab.Pane>
          <Loader active>Loading audit logs...</Loader>
        </Tab.Pane>
      );
    }

    if (error) {
      return (
        <Tab.Pane>
          <Message negative>
            <Message.Header>Error</Message.Header>
            <p>{error}</p>
            <Button onClick={this.fetchAuditLogs}>Retry</Button>
          </Message>
        </Tab.Pane>
      );
    }

    return (
      <Tab.Pane>
        <Container fluid className="spaced">
          <div style={{ marginBottom: "1rem" }}>
            <Header as="h3">Catalog Activity Log</Header>
            <HeaderSubHeader>{total} logs found</HeaderSubHeader>
          </div>
        </Container>
        <Container fluid className="bo-search-body">
          <Grid>
            <Grid.Row>
              <Grid.Column width={16}>
                {auditLogs.length > 0 ? (
                  <ActivityLogList auditLogs={auditLogs} />
                ) : (
                  <Message info>
                    <Message.Header>No audit logs found</Message.Header>
                    <p>No catalog activity has been recorded yet.</p>
                  </Message>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Tab.Pane>
    );
  };

  render() {
    const user = sessionManager.user || {};
    const isAdmin = authenticationService.hasRoles(user, ["admin"]);

    const panes = [];

    panes.push({
      menuItem: "Catalog Activity Log",
      render: this.renderCatalogLogTab,
    });

    // Only show Overview tab for admins
    if (isAdmin) {
      panes.unshift({
        menuItem: "Overview",
        render: this.renderOverviewTab,
      });
    }

    return (
      <>
        <Header as="h2">Audit Log</Header>
        <Tab panes={panes} />
      </>
    );
  }
}
